<script>
    // -- IMPORTS
    import { inview } from 'svelte-inview';
    import { onMount } from 'svelte';

    // -- VARIABLES
    let inView = $state(false);
    let absoluteCharIndex = 0;

    /** @type {{text: any, animateByCharacter?: boolean}} */
    let { text, animateByCharacter = false } = $props();

    // -- FUNCTIONS
    function getCurrentDelay() {
        absoluteCharIndex += 5;
        return absoluteCharIndex;
    }

    onMount(() => {
        absoluteCharIndex = 0;

        setTimeout(() => {
            if (!inView) inView = true;
        }, 1000);
    });
</script>

<style lang="stylus">
    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    span
        font-family: inherit
        font-size: inherit
        font-weight: inherit

    .char
        width: 100%
        opacity: 0

        +media(desktop)
            width: auto

    .slide-in-bottom
        animation: slide-in-bottom 1.8s ease both

    @keyframes slide-in-bottom
        0%
            transform: translateY(60px)
            opacity: 0

        100%
            transform: translateY(0)
            opacity: 1
</style>

<span
    use:inview={{
        unobserveOnEnter: true,
        threshold: 0.1
    }}
    on:inview_enter={() => inView = true}
>   
    {#if typeof text === 'string'}

        {#if animateByCharacter}
            {#each text.split(' ') as word}
                <span class="word">
                    {#each word.split('') as char}
                        <span
                            class="char {inView ? 'slide-in-bottom' : ''}"
                            style="animation-delay: {getCurrentDelay()}ms"
                        >
                            {char}
                        </span>
                    {/each}
                    &nbsp;
                </span>
            {/each}
        {:else}
            <span class="char {inView ? 'slide-in-bottom' : ''}">
                {@html text}
            </span>
        {/if}
    {/if}

</span>
